import { fetchApi } from '@/config/axiosSetting';
import {
  GetDamagedCustomerImageTabsAlertsQueryParamType,
  GetDamagedCustomerImageTabsAlertsQueryResponseQueryType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerImageTabsAlerts/getDamagedCustomerImageTabsAlertsQuery.type';

export const getDamagedCustomerImageTabsAlertsQueryFunctions = (
  params: GetDamagedCustomerImageTabsAlertsQueryParamType,
): Promise<GetDamagedCustomerImageTabsAlertsQueryResponseQueryType> =>
  fetchApi.get(
    `property/reports/${params.id}/accident_users/damaged/images/customer/entry_tabs/alert/`,
    {
      params: {
        damaged_id: params.damage_id,
      },
    },
  );
